<script setup lang="ts">
const solutions = [
  'Saldo aktif bisa ditarik ke rekeningmu secara real time.',
  'Paket masih di jalan, dana COD cair duluan dengan COD Advance.',
  'Tidak perlu menunggu berhari-hari untuk menerima dana COD-mu.'
]

const tabs = [
  {
    value: 'tab-1',
    icon: 'material-symbols:bolt-outline-rounded',
    label: 'Rilis Dana COD Cepat',
    description:
      'Dana COD dirilis ke saldo aktif di hari yang sama paket diterima pelanggan, dan selanjutnya dapat ditarik ke rekening secara real time.',
    carousels: [
      {
        title: 'Pesan Pengiriman Paket COD',
        description:
          'Pesan pengiriman paket dengan metode pembayaran COD melalui aplikasi atau dashboard KiriminAja.'
      },
      {
        title: 'Paket Diterima Kurir',
        description:
          'Paket diambil atau diterima kurir untuk diantarkan ke pelanggan.'
      },
      {
        title: 'Paket Sampai, Dana COD Rilis',
        description:
          'Pelanggan menerima paket dan membayar dana COD. KiriminAja akan merilis dana COD ke saldo aktif di hari yang sama dan dapat ditarik secara real time.'
      }
    ]
  },
  {
    value: 'tab-2',
    label: 'Penarikan Real Time',
    icon: 'material-symbols:speed-outline',
    description:
      'Saldo aktif akan bertambah di hari yang sama paket COD diterima pelanggan. Selanjutnya, saldo aktif bisa ditarik ke rekeningmu secara real time.',
    carousels: [
      {
        title: 'Dana COD Rilis ke Saldo Aktif',
        description:
          'KiriminAja akan merilis dana COD ke saldo aktif di hari yang sama paket diterima pelanggan.'
      },
      {
        title: 'Tarik Saldo Aktif',
        description:
          'Lakukan penarikan saldo aktif melalui aplikasi atau dashboard KiriminAja. Minimum saldo yang bisa ditarik adalah Rp20.000.'
      },
      {
        title: 'Saldo Ditransfer ke Rekeningmu',
        description:
          'Setelah proses penarikan berhasil, saldo akan langsung ditransfer ke rekening yang terdaftar di KiriminAja.'
      }
    ]
  },
  {
    value: 'tab-3',
    label: 'COD Advance',
    icon: 'material-symbols:hand-package-outline',
    description:
      'COD Advance adalah solusi percepatan pencairan nilai barang COD saat paketmu masih dalam perjalanan, untuk lancarkan arus kas bisnismu.',
    carousels: [
      {
        title: 'Penuhi Syarat COD Advance',
        description:
          'Jika riwayat nilai barang COD, jumlah paket COD, dan tingkat retur paketmu memenuhi syarat, kamu dapat mengajukan COD Advance.'
      },
      {
        title: 'Ajukan COD Advance',
        description:
          'Kamu bisa menentukan nominal pengajuan COD Advance-mu dalam rentang sesuai dengan nilai COD yang dapat dicairkan.'
      },
      {
        title: 'COD Advance Masuk Rekening',
        description:
          'Nominal yang kamu ajukan akan dicairkan dengan metode transfer ke rekening sesuai dengan ketentuan pencairan COD Advance'
      },
      {
        title: 'Penyelesaian Otomatis',
        description:
          'Setiap dana COD yang masuk ke saldo aktif berikutnya, akan secara otomatis digunakan untuk mengganti dana COD Advance yang sudah kamu cairkan.'
      }
    ]
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container flex flex-col gap-11 py-7 lg:pb-12 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiSectionWrapper
      class="pt-10 bg-transparent relative z-10"
      image-class="lg:order-first"
      title="Rilis Dana COD Cepat, Tanpa Tunggu Lama"
      description="Paket tiba di tujuan, dana COD langsung masuk saldo aktif di hari yang sama."
      hero-image="/assets/home-v4/framre-cod-fast-release.webp"
      :with-action="false"
      :items="solutions"
    />
    <UiContainer>
      <UiTabBase
        class="relative z-10"
        :tabs="tabs"
        :default-value="tabs?.[0]?.value"
      >
        <template v-for="(tab, index) in tabs" :key="index" #[tab.value]>
          <div class="pt-5 flex flex-col gap-5">
            <p class="text-lg">{{ tab.description }}</p>
            <UiCarouselFeature :items="tab.carousels" />
          </div>
        </template>
      </UiTabBase>
    </UiContainer>
  </div>
</template>
